'use client';
import { useSearchParams } from 'next/navigation';
import { FC, PropsWithChildren, useEffect, useState } from 'react';

import Modal from '../Modal';
import Button from '../Button';
import LoginForm from '../LoginForm';

import { IModalsDictionary } from '@/dictionaries/components/modals/types';
import XIcon from '../Icons/X';
import { FaRegUserCircle } from 'react-icons/fa';
import { Title, Description } from '@radix-ui/react-dialog';

interface LoginModalProps extends PropsWithChildren {
  dict: IModalsDictionary;
  text?: boolean;
  className?: string;
  isHeader?: boolean;
  lang: string;
}

const LoginModal: FC<LoginModalProps> = ({
  dict,
  text = false,
  className,
  isHeader = false,
  lang,
  children,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const searchParams = useSearchParams();

  function renderModalTrigger() {
    if (children) {
      return children;
    }

    if (text) {
      return (
        <button className="appearance-none outline-none text-primary text-lg font-averta-semibold cursor-pointer">
          {isHeader ? dict.loginModal.login : dict.loginModal.title}
        </button>
      );
    }

    return (
      <Button
        variant="outline"
        className={
          className
            ? className
            : 'h-10 w-10 px-0 desktop:text-gray-900 bg-[#EBBF20] hover:bg-white border-[#EBBF20] transition-colors group'
        }>
        {/* {isHeader ? dict.loginModal.login : dict.loginModal.title} */}
        {modalIsOpen ? (
          <XIcon className="h-4 w-4 text-[#E4B321]" />
        ) : (
          <FaRegUserCircle
            size={16}
            className="fill-white group-hover:fill-black transition-colors duration-[800ms]"
          />
        )}
      </Button>
    );
  }

  useEffect(() => {
    if (searchParams.get('openLogin')) {
      setModalIsOpen(true);
    }
  }, [searchParams]);

  return (
    <Modal.Root open={modalIsOpen} onOpenChange={setModalIsOpen}>
      <Modal.Trigger>{renderModalTrigger()}</Modal.Trigger>
      <Modal.Content
        contentCustomClass="md:!w-[600px]"
        onOpenChange={setModalIsOpen}>
        <Title className="hidden" />
        <Description className="hidden" />
        <LoginForm lang={lang} isHeader={isHeader} dict={dict} />
      </Modal.Content>
    </Modal.Root>
  );
};

export default LoginModal;
